export const LANG_ENUM  = {
  RU: "ru",
  EN: "en",
  CN: "cn"
};

export const LANGS = [
  {key:LANG_ENUM.RU, locale: "ruRU", label: "Русский"},
  {key:LANG_ENUM.EN, locale: "enUS", label: "English"},
  {key:LANG_ENUM.CN, locale: "zhCN", label: "中文"},
];
